import { observer } from "mobx-react-lite";
import { Form as FinalForm, Field } from "react-final-form";
import { isRequired, combineValidators } from "revalidate";
import React, { useContext, useEffect, useState } from "react";

// reactstrap components
import { Alert, Button, FormGroup, Form, Row, Col } from "reactstrap";
import { FORM_ERROR } from "final-form";
import { RootStoreContext } from "../../app/stores/rootStore";
import TextInput from "../common/TextInput";
import LogoCompany from "../common/LogoCompany";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import Loader from "../common/Loader";
import { RegistrationFormValues } from "../../app/models/user";
import RegistrationConfirmModal from "../common/RegistrationConfirmModal";

export const RegisterForm = () => {
  const rootStore = useContext(RootStoreContext);
  const { register } = rootStore.userStore;
  const { showLoginForm, showResetPwdForm } = rootStore.authStore;
  const {
    company,
    loadCompanyRegistrationSettings,
    loadingCompanyRegistration,
    companyRegistrationSettings,
  } = rootStore.commonStore;
  const [t] = useTranslation(
    ["registration", "translation", "errors"],
    translationHookOptions
  );

  const [formValue, setFormValue] = useState(new RegistrationFormValues());
  const [OpenModal, setOpenModal] = useState(false);
  const [successRegistration, setSuccessRegistration] = useState(false);
  const linkToLogin = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    showLoginForm();
  };

  const linkToResetPwd = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    showResetPwdForm();
  };

  useEffect(() => {
    if (company)
      loadCompanyRegistrationSettings(company.id)
        .then((dto) => {
          if (dto) {
            let form = new RegistrationFormValues();
            form.firstName = "";
            form.lastName = "";
            form.password = "";
            form.approverEmail = "";
            form.companyId = company ? company.id : 0;
            form.phoneNumber = "";
            setFormValue(form);
          }
        })
        .catch();
    return () => {};
  }, []);

  if (loadingCompanyRegistration) return <Loader></Loader>;
  return (
    <>
      <div className="form-wrapper  mt-0">
        <div>
          <LogoCompany className="loginLogo" />
        </div>
        <h5 style={{marginTop:"5%"}}>{t("title")}</h5>
        <FinalForm
          initialValues={formValue}
          onSubmit={(values: RegistrationFormValues) => {
            setSuccessRegistration(false);
            if (!companyRegistrationSettings!.enabledDisclaimer) {
              values.confermRegistration = true;
              return register(values, values.confermRegistration)
                .then(() => {
                  setSuccessRegistration(true);
                
                })
                .catch((error) => ({
                  [FORM_ERROR]: error,
                }));
            } else {
              // caso in cui deve apparire il disclaimer
              values.confermRegistration = false;
              setFormValue(values);
              return register(values,values.confermRegistration)
                .then(() => {
                  setOpenModal(true);
                })
                .catch((error) => ({
                  [FORM_ERROR]: error,
                }));
            }
          }}
          validate={(values) => {
            let errors = {};
            let errorNum = 0;
            if (!values.email) errorNum++;
            if (
              companyRegistrationSettings?.enabledFirstName &&
              !values.firstName
            )
              errorNum++;
            if (
              companyRegistrationSettings?.enabledLastName &&
              !values.lastName
            )
              errorNum++;
            if (
              companyRegistrationSettings?.enabledPassword &&
              !values.password
            )
              errorNum++;
            if (
              companyRegistrationSettings?.enabledPhoneNumber &&
              !values.phoneNumber
            )
              errorNum++;
            if (
              companyRegistrationSettings?.enabledApprover &&
              !values.approverEmail
            )
              errorNum++;
            if (errorNum === 0) return errors;
            else return { count: errorNum };
          }}
          render={({
            values,
            handleSubmit,
            submitting,
            submitError,
            invalid,
            pristine,
            dirtySinceLastSubmit,
          }) => (
            <Form onSubmit={handleSubmit} role="form">
              {companyRegistrationSettings!.enabledFirstName && (
                <>
                  <FormGroup className="form-group input-group-lg">
                    <Field
                      className="form-control"
                      name="firstName"
                      component={TextInput}
                      placeholder={t("name_placeholder")}
                    />
                  </FormGroup>
                </>
              )}
              {companyRegistrationSettings!.enabledLastName && (
                <>
                  <FormGroup className="form-group input-group-lg">
                    <Field
                      className="form-control"
                      name="lastName"
                      component={TextInput}
                      placeholder={t("last_name_placeholder")}
                    />
                  </FormGroup>
                </>
              )}

              <FormGroup className="form-group input-group-lg">
                <Field
                  className="form-control"
                  name="email"
                  component={TextInput}
                  placeholder={t("email_placeholder", { ns: "translation" })}
                  type="email"
                  autoComplete="email"
                />
              </FormGroup>
              {companyRegistrationSettings!.enabledPassword && (
                <>
                  <FormGroup className="form-group input-group-lg">
                    <Field
                      className="form-control"
                      name="password"
                      component={TextInput}
                      placeholder={t("password_placeholder", {
                        ns: "translation",
                      })}
                      type="password"
                    />
                    <Field
                      className="form-control"
                      name="companyId"
                      component={TextInput}
                      type="hidden"
                    />
                  </FormGroup>
                </>
              )}
              {companyRegistrationSettings!.enabledPhoneNumber && (
                <>
                  <FormGroup className="form-group input-group-lg">
                    <Field
                      className="form-control"
                      name="phoneNumber"
                      component={TextInput}
                      placeholder={t("telphonenumber_placeholder", {
                        ns: "translation",
                      })}
                    />
                  </FormGroup>
                </>
              )}
              {companyRegistrationSettings!.enabledfavouriteLanguage &&
                companyRegistrationSettings!.allLanguages && (
                  <>
                    <FormGroup>
                      <Field
                        id="languageId"
                        name="languageId"
                        component="select"
                        className="form-control-alternative form-control"
                        autoComplete="off"
                      >
                        <option value="0">
                          {t("select_languages", { ns: "registration" })}
                        </option>
                        {companyRegistrationSettings!.allLanguages.map((l) => (
                          <option key={l.id} value={l.id}>
                            {t("language_" + l.locale, { ns: "translation" })}
                          </option>
                        ))}
                      </Field>
                    </FormGroup>
                  </>
                )}
              {companyRegistrationSettings &&
                companyRegistrationSettings.enabledApprover && (
                  <>
                    <FormGroup className="form-group input-group-lg">
                      <Field
                        className="form-control"
                        name="approverEmail"
                        component={TextInput}
                        placeholder={t("domainApprover_placeholder", {
                          domain: companyRegistrationSettings!.approverDomain,
                        })}
                      />
                    </FormGroup>
                  </>
                )}
              <div>
                {submitError && !dirtySinceLastSubmit && (
                <Alert color="danger" className="w-100">
                  {submitError.data  && submitError.data.errors ? (
                   Array.isArray(submitError.data.errors) ? (
                    <ul style={{ textAlign: "left" , paddingLeft:"3%"}}>
                      {submitError.data.errors
                        .map((error: any) => error.errorCode)
                        .map((errorCode: any, index: any) => (
                          <li key={index} style={{marginTop:"3%"}}>
                            {" "}
                            {t(errorCode, { ns: "errors" })}.
                          </li>
                        ))}
                    </ul>
                    ) : (
                      <ul style={{ textAlign: "left" , paddingLeft:"3%"}}>
                      {Object.values<string>(submitError.data.errors)
                        .flat()
                        .map((err, i) => (
                          <li key={i} style={{marginTop:"3%"}}>{err.toString()}.</li>
                        ))}
                    </ul>
                    )
                  ) : null}
                 </Alert>
                 )}
              </div>
              <div>
                {successRegistration && !dirtySinceLastSubmit &&(
                  <>
                    <Alert color="success" className="w-100">
                      {(!companyRegistrationSettings?.enabledApprovalRegistrationRequest &&  !companyRegistrationSettings?.enabledApprover )? (
                        <>
                           {t("messagge_success_automaticRegistration", {
                            ns: "registration",
                          })}
                        </>
                      ) : (
                        <>
                        {t("messagge_success", { ns: "registration" })}
                       
                        </>
                      )}
                    </Alert>
                  </>
                )}
              </div>
              <div className="text-center">
                <Button
                  disabled={invalid && !dirtySinceLastSubmit}
                  // disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                  className="btn loginButton btn-block btn-lg"
                  color="dark"
                  type="submit"
                >
                  {t("submit_button")}
                </Button>
              </div>
            </Form>
          )}
        />
        <Row className="mt-3">
        <Col style={{paddingRight:"0px"}}>
            <a
              className="text-muted text-underline"
              href="/#"
              onClick={(e) => linkToResetPwd(e)}
            >
              <u>{t("forgot_password", { ns: "translation" })}</u>
            </a>
          </Col>
          <Col>
            <p className="text-muted">
              {t("registration_already_registered", { ns: "translation" })}
            </p>
            <a
              className="btn btn-dark loginButton text-white btn-outline-light btn-sm"
              href="#"
              onClick={(e) => linkToLogin(e)}
            >
              {t("login", { ns: "translation" })}
            </a>
          </Col>
        </Row>
      </div>
      <RegistrationConfirmModal
        title= {t("disclaimer", { ns: "registration" })}
        isOpen={OpenModal}
        toggle={() => setOpenModal(!OpenModal)}
        action={() => {
          {
            setSuccessRegistration(false);
            formValue.confermRegistration = true;
            register(formValue, formValue.confermRegistration)
              .then(() => {
                setSuccessRegistration(true);
              })
              .catch();
          }
        }}
        message={""}
        disclaimerLanguages={companyRegistrationSettings!.disclaimerDetails}
        allLanguages={companyRegistrationSettings!.allLanguages}
      ></RegistrationConfirmModal>
    </>
  );
};

export default observer(RegisterForm);
